// ABOUTME: Checkbox picker for units of measure, constrained to the backend registry (no free text).
import React from 'react'

import {InlineCheckbox} from '../../CountryConfigurations/components/InlineCheckbox'
import type {UnitOfMeasureRef} from '../types'

interface UomPickerProps {
  options: UnitOfMeasureRef[]
  selected: string[]
  onChange: (ids: string[]) => void
  'data-cy'?: string
}

export const UomPicker: React.FC<UomPickerProps> = ({options, selected, onChange, 'data-cy': dataCy}) => {
  const toggle = (id: string, checked: boolean) =>
    onChange(checked ? [...selected, id] : selected.filter((v) => v !== id))

  // Keep any already-selected id not in the registry so it isn't silently dropped on save.
  const unknown = selected.filter((id) => !options.some((o) => o.id === id))

  return (
    <div className="grid grid-cols-2 gap-x-6 gap-y-1 md:grid-cols-4" data-cy={dataCy}>
      {options.map((o) => (
        <label key={o.id} className="flex items-center gap-2 text-sm text-foreground">
          <InlineCheckbox
            checked={selected.includes(o.id)}
            label={`${o.name} (${o.id})`}
            onChange={(v) => toggle(o.id, v)}
            data-cy={`uom-${o.id}`}
          />
          {o.displaySymbol || o.id}
        </label>
      ))}
      {unknown.map((id) => (
        <label key={id} className="flex items-center gap-2 text-sm text-error">
          <InlineCheckbox checked label={id} onChange={(v) => toggle(id, v)} data-cy={`uom-${id}`} />
          {id} (unknown)
        </label>
      ))}
    </div>
  )
}
